import { render, staticRenderFns } from "./17.vue?vue&type=template&id=4b879e76&"
import script from "./17.vue?vue&type=script&lang=js&"
export * from "./17.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports